import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
export default function HealthIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-testid": "icon-health",
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M41.554 6.979c-5.227.201-8.888 4.118-10.36 6.011-.313.403-1.015.34-1.26-.108-1.125-2.052-4.094-6.264-9.723-6.792C5.983 4.756-.242 18.54 4.65 30.1 9.96 42.657 29.993 55 29.993 55s23.762-13.956 26.679-28.901c2.375-12.17-3.557-19.565-15.118-19.12z",
    fill: "#F58F97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.644 31.735c3.782-1.891-15.65 20.17-22.605 18.431-8.727-2.182 14.954-14.606 22.605-18.431z",
    fill: "#F35C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.347 12.056c-4.225 3.577-4.403 10.676-2.055 13.117 2.245 2.333 18.2-9.457 14.678-14.032-3.1-4.027-8.776-2.343-12.623.915z",
    fill: "#F8B9BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.206,
    cy: 29.399,
    r: 12.787,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.787,
    y: 22.14,
    width: 4.838,
    height: 14.515,
    rx: 0.573,
    fill: "#E32645"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.464,
    y: 27.671,
    width: 4.147,
    height: 14.515,
    rx: 0.573,
    transform: "rotate(90 37.464 27.67)",
    fill: "#E32645"
  }));
}